import { ApolloClient, InMemoryCache, ApolloLink, createHttpLink, from } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { RestLink } from "apollo-link-rest";
import { onError } from "@apollo/client/link/error";

import { DEFAULT_GQL_URI } from "constants/graphQL";
import { getHeaderContentType, getMarketplaceGQLHTTPHeaders } from "utils/httpClient";
import { APOLLO_LINK_BASE_URLS } from "constants/apolloLinkRest";
import { REACT_APP_SIGNUP_LOCALITY } from "config";
import { getAccessTokenId } from "utils/auth";

const httpLink = createHttpLink({
  uri: DEFAULT_GQL_URI,
});

const apolloRESTLink = new ApolloLink((operation, forward) => {
  const { variables } = operation;
  const { headers } = variables as {
    headers: {
      [key: string]: string;
    };
  };
  const defaultHeaders = operation.getContext().headers || {};

  operation.setContext({
    headers: {
      ...defaultHeaders,
      ...headers,
      authorization: `Bearer ${getAccessTokenId()}`,
    },
  });

  return forward(operation);
});

const errorLink = onError(_ => {});

const restLink = new RestLink({
  credentials: "omit",
  uri: REACT_APP_SIGNUP_LOCALITY,
  endpoints: APOLLO_LINK_BASE_URLS,
  responseTransformer: async response => {
    try {
      const transformedResponse = await response.json();

      return { data: transformedResponse || null };
    } catch (transformError) {
      console.error(`ResponseTransformer: ${transformError}`);
    }

    return { data: null };
  },
  defaultSerializer: (body, headers) => {
    let modifiedBody = body;
    const currentHeaderContentType = headers.get("content-type");

    if (currentHeaderContentType === getHeaderContentType("APPLICATION_JSON")) {
      modifiedBody = JSON.stringify(body);
    }

    headers.set("accept", "application/json, text/plain, */*");

    return {
      body: modifiedBody,
      headers,
    };
  },
});

const authLink = setContext(async (_, { headers }) => {
  return {
    headers: {
      ...headers,
      ...(await getMarketplaceGQLHTTPHeaders()),
    },
  };
});

const defaultApolloClient = () => {
  const link = ApolloLink.split(
    operation => {
      const isRESTDirective = !!operation?.variables?.baseURL;

      return isRESTDirective;
    },
    from([apolloRESTLink, errorLink, restLink]),
    from([authLink, httpLink]),
  );

  return new ApolloClient({
    link,
    cache: new InMemoryCache(),
  });
};

export default defaultApolloClient;
